import { render, staticRenderFns } from "./DirectorBigQueryView.pug?vue&type=template&id=37458631&scoped=true&lang=pug&external"
import script from "./DirectorBigQueryView.js?vue&type=script&lang=js&external"
export * from "./DirectorBigQueryView.js?vue&type=script&lang=js&external"
import style0 from "./DirectorBigQueryView.vue?vue&type=style&index=0&id=37458631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37458631",
  null
  
)

export default component.exports